import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import PrivacyPolicyText from '../components/PrivacyPolicyText';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title: window.location.title,
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen ">
      <Helmet>
        <title>Explore Lipaworld Privacy Policy | Lipaworld Corp</title>
        <meta
          name="description"
          content="Learn how Lipaworld protects your data with industry-leading security, encryption, and privacy measures to ensure safe financial transactions and shopping."
        />
        <link rel="canonical" href="https://www.lipaworld.com/privacy-policy" />
      </Helmet>
      <div className="container mx-auto px-4">
        <Header />
        <main>
          <PrivacyPolicyText />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
